// extracted by mini-css-extract-plugin
export var contrastLow = "_3d-1";
export var externalLink = "_3d-2";
export var externalLinkIcon = "_3d-3";
export var link = "_3d-0";
export var linkLabel = "_3d-4";